import React, { Fragment, useCallback } from 'react';
import { useFormik } from 'formik';
import { useModal } from 'context/modal';
import { ModalButton } from 'components/newComponents/Buttons';
import Modal from 'components/newComponents/Modal';
import { useUpdateInsuranceValuation } from 'hooks/query/useJob';
import { preventArrowUpDown } from 'utils/preventArrowUpDown';
import * as Yup from 'yup';

const InsuranceValuation = () => {
  const { info, modalNames, close } = useModal();
  const modalName = modalNames.insuranceValuation;

  const isVisible = info(modalName).visible;
  const params = info(modalName).params;
  const jobId = params?.jobId;
  const initialValuation = params?.valuation || '';
  const onSuccessCb = params?.onSuccess;

  const { mutate: updateInsuranceValuation } = useUpdateInsuranceValuation();

  const submitHandler = useCallback(
    (values) => {
      updateInsuranceValuation(
        { job_id: jobId, value: values.valuation },
        {
          onSuccess: () => {
            if (typeof onSuccessCb === 'function') onSuccessCb();
            close(modalName);
          },
        }
      );
    },
    [updateInsuranceValuation, close, onSuccessCb, jobId, modalName]
  );

  const { values, handleSubmit, handleChange, errors, dirty } = useFormik({
    initialValues: {
      valuation: initialValuation,
    },
    onSubmit: submitHandler,
    validationSchema: Yup.object().shape({
      valuation: Yup.string().required('Required!'),
    }),
  });

  return (
    <Fragment>
      <Modal show={isVisible} style={{ width: 560 }} onHide={() => close(modalNames.insuranceValuation)} header="Add Insurance Valuation">
        <form onSubmit={handleSubmit}>
          <div className="new-table modal">
            <div className="new-table--row">
              <div className="new-table--row--item">
                <input
                  type="number"
                  onKeyDown={preventArrowUpDown}
                  name="valuation"
                  placeholder="Amount"
                  value={values.valuation}
                  onChange={handleChange}
                />

                {errors?.valuation && <span className="error">{errors?.valuation}</span>}
              </div>
            </div>
          </div>

          <div className="footer-buttons">
            <ModalButton title="Cancel" variant="cancel" onClick={() => close(modalNames.insuranceValuation)} />
            <ModalButton type="submit" title="Submit" variant="confirm" disabled={!dirty} />
          </div>
        </form>
      </Modal>
    </Fragment>
  );
};

export default InsuranceValuation;
